import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IBreadcrumbsService = ( createDecorator('IEditorBreadcrumbsService'));
export { IBreadcrumbsService };
